import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

// components
//import Navbar from "./components/Navbar.jsx";
import AppFooter from "./components/AppFooter.jsx";
import { Sidebar } from "@cadenza/ui";
import { navLinks } from "./config/navLinks.js";
import { rightControls } from "./config/rightControls.js";
import { DarkModeToggle } from "@cadenza/theme";
import About from "./staticpages/About.jsx";
import { Feedback } from "@cadenza/shared-staticpages";
import FreeModeBanner from "./free-mode-banner.jsx";
import { MessageBanner } from "@cadenza/messages";
import "@cadenza/messages/styles";

const RADManager = lazy(() =>
  import("@cadenza/rad-react").then((m) => ({ default: m.RADManager }))
);

export default function App() {
  return (
    <div className="site-container">
      <Sidebar
        title="RAD Tool"
        links={navLinks}
        leadingControls={[{ key: "dark", Component: DarkModeToggle }]}
        trailingControls={rightControls}
        pinnedInitially={false}
      />

      <main className="sidebar-page-shell">
        <FreeModeBanner />
        <Suspense fallback={<div>Loading…</div>}>
          <Routes>
            <Route path="/" element={<RADManager />} />
            <Route path="/rad/:radId" element={<RADManager />} />
            <Route path="/about" element={<About />} />
            <Route path="/feedback" element={<Feedback />} />
          </Routes>
        </Suspense>
        <MessageBanner />
        <AppFooter />
      </main>
    </div>
  );
}
